
/* styles */
require("!!vue-style-loader!css-loader?minimize!../../node_modules/vue-loader/lib/style-rewriter?id=data-v-57ff062f!sass-loader!../../node_modules/vue-loader/lib/selector?type=styles&index=0!./ProductAttribute.vue")

var Component = require("!../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../node_modules/vue-loader/lib/selector?type=script&index=0!./ProductAttribute.vue"),
  /* template */
  require("!!../../node_modules/vue-loader/lib/template-compiler?id=data-v-57ff062f!../../node_modules/vue-loader/lib/selector?type=template&index=0!./ProductAttribute.vue"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/components/ProductAttribute.vue
// module id = 528
// module chunks = 2